import {CacheState} from "./CacheState";
import {ApplicationProperties} from "../../model/ApplicationProperties";

export class ApplicationPropertiesState implements CacheState {
    constructor(public applicationProperties: ApplicationProperties | null = null,
                public pendingRequest: boolean = false,
                public loaded: boolean = false) {}
}